export default __webpack_public_path__ + "static/media/branding_red.png";